import script from "./BasePicture.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasePicture.vue?vue&type=script&setup=true&lang=ts"

import "./BasePicture.vue?vue&type=style&index=0&id=69956393&lang=scss"

const __exports__ = script;

export default __exports__